export abstract class Spacings {
  static homePageSectionPadding: string = "py-8 py-sm-10 py-md-16";
  static homePageHeadingMargin: string = "mt-10 mt-sm-12 mt-md-16";
}
